import { render, staticRenderFns } from "./of_dialog_approval.vue?vue&type=template&id=6e6230aa&scoped=true&"
import script from "./of_dialog_approval.vue?vue&type=script&lang=js&"
export * from "./of_dialog_approval.vue?vue&type=script&lang=js&"
import style0 from "./of_dialog_approval.vue?vue&type=style&index=0&id=6e6230aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6230aa",
  null
  
)

export default component.exports